import { render, staticRenderFns } from "./NotSupported.vue?vue&type=template&id=06dde734&"
import script from "./NotSupported.vue?vue&type=script&lang=ts&"
export * from "./NotSupported.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports